import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { axiosClient } from '../../../core/axios-client'

const fetchReservedBikes = createAsyncThunk(
  'reservedBikes/fetchReservedBikes',
  async ({ filters = {} } = {}, { rejectWithValue }) => {
    try {
      const response = await axiosClient.get('/user/reserved-bikes/', {
        params: { ...filters }
      })
      return response.data
    } catch (err) {
      return rejectWithValue(err.response?.data || err.message)
    }
  }
)

const initialState = {
  listItems: {
    items: [],
    page: 1,
    page_size: 10,
    count: 0
  },
  reports: [],
  loading: false,
  error: null
}

export const slice = createSlice({
  name: 'reservedBikes',
  initialState,
  reducers: {
    setListItems(state, { payload }) {
      state.listItems = {
        ...state.listItems,
        ...payload
      }
      state.reports = state.listItems.items
    },
    resetListItems(state) {
      state.listItems = { items: [], page: 1, page_size: 10, count: 0 }
      state.reports = []
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchReservedBikes.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchReservedBikes.fulfilled, (state, { payload }) => {
        state.loading = false
        if (!payload) {
          state.listItems.items = []
          state.listItems.count = 0
          state.reports = []
          return
        }
        const { count = 0, results = null } = payload
        const items = Array.isArray(results)
          ? results
          : Array.isArray(payload)
            ? payload
            : (payload.results || [])
        state.listItems = {
          ...state.listItems,
          items,
          count
        }
        state.reports = items
      })
      .addCase(fetchReservedBikes.rejected, (state, { payload }) => {
        state.loading = false
        state.error = payload
      })
  }
})

export const { setListItems, resetListItems } = slice.actions

export {
  fetchReservedBikes
}

export default slice.reducer
